
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "TreeNode",
  mixins: [SistemaMixin],
  props: {
    node: {
      type: Object,
      required: true,
    },
    dreGrupos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dreGruposOptions() {
      return [
        { value: null, text: "Não classificado" },
        ...this.dreGrupos.map((g) => ({ value: g.id, text: g.label })),
      ];
    },
    dreGrupoLabel() {
      if (!this.node.dre_grupo) return null;
      const grupo = this.dreGrupos.find((g) => g.id === this.node.dre_grupo);
      return grupo ? grupo.label : null;
    },
  },
  data() {
    return {
      isOpen: true,
      isHovered: false,
      modalVisible: false,
      editedName: this.node.descricao,
      editedDreGrupo: this.node.dre_grupo || null,
    };
  },
  methods: {
    showModal() {
      this.editedName = this.node.descricao;
      this.editedDreGrupo = this.node.dre_grupo || null;
      this.modalVisible = true;
    },
    async saveEdit() {
      this.addLoadingToButton("saveEdit");
      this.node.descricao = this.editedName;
      this.node.dre_grupo = this.editedDreGrupo;
      await this.$http.post("/financeiro/update-plano", this.node);
      this.$toast.success("Plano atualizado com sucesso!");
      this.modalVisible = false;
      this.removeLoadingToButton("saveEdit");
    },
    addChild() {
      this.$emit("add-child", this.node);
    },
    deleteNode() {
      this.$emit("delete-node", this.node);
    },
  },
};
